import List from "@/components/list";
import router from "@/router";
import Bus from "./Bus.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  //详情
  function infoFuc(data) {
    Bus.$emit("infoBook", data);
  }
  // 学员作业
  function goClassGroup(data) {
    let query = { workId:data.uuid};
    if (data.classChildId) {
      query.childId = data.classChildId;
    }
    router.push({
      path: "studentWorkPage",
      query: query,
    });
  }
  const Deal = ({ props: { vo } }) => {
    const data = vo.row;
    return (
      <div class="deal-group">
        <el-tooltip
          content="学员作业"
          placement="top"
          style="margin-right:20px"
          v-permission="studentWorkPage:page"
        >
          <i class="icon_zuoye_grey_icon"
            onClick={() => goClassGroup(data)}
          ></i>
        </el-tooltip>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "作业名称",
      prop: "workName",
      minWidth: "150",
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => infoFuc(vo.row)}
        >
          {vo.row.workName}
        </el-button>
      )
    },
    {
      label: "作业类型",
      prop: "workTypeName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "批改方式",
      prop: "workReviewTypeName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "作业开始时间",
      prop: "createDate",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "作业结束时间",
      prop: "deadline",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "完成情况",
      prop: "finishSituation",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "120",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
